import { Injectable } from '@angular/core';
import { Route, UrlSegment } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from './services/user.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard {
  constructor(public userService: UserService) {}

  /*canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    console.log('CAN ACTIVATE');
    console.log(state);

    return false;
  }*/

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise(async (resolve) => {
      await this.userService.waitForUser();

      const path = segments.length ? segments[0].path : 'default';

      return resolve(this.userService.userHasSitePermission(path || 'admin', true));
    });
  }
}
